class ChatService {
  static baseUrl = "/api";

  static async fetchChatResponse(input, lastMessages) {
    const url = `${ChatService.baseUrl}/chat`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query: input, conversation: lastMessages }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching chat response:", error);
      throw error;
    }
  }

  // Streams the answer token-by-token via SSE. onToken is called with each
  // token as it arrives; resolves with the complete text. Falls back to
  // throwing on HTTP or stream errors so callers can show partial text.
  static async streamChatResponse(input, lastMessages, onToken) {
    const url = `${ChatService.baseUrl}/chat/stream`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: input, conversation: lastMessages }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let fullText = "";

    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      let idx;
      while ((idx = buffer.indexOf("\n\n")) !== -1) {
        const event = buffer.slice(0, idx).trim();
        buffer = buffer.slice(idx + 2);
        if (!event.startsWith("data: ")) continue;
        const payload = event.slice(6).trim();
        if (payload === "[DONE]") continue;
        let data;
        try {
          data = JSON.parse(payload);
        } catch {
          continue;
        }
        if (data.error) throw new Error(data.error);
        if (data.token) {
          fullText += data.token;
          onToken(data.token);
        }
      }
    }
    return fullText;
  }
}

export default ChatService;
